import { formatCurrencyShort } from "@/lib/utils";
import { RootState } from "@/redux/store";
import { useGetDashboardCount } from "@/services";
import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { cards } from "./consts";
import moment from "moment";

const useBudgetCard = () => {
  const {
    communityData: communityDetail,
    currentFinanceYear,
  } = useSelector((state: RootState) => state.currentData);

  const {
    data: prevYearsCounts,
    isLoading: isPrevYearsCountsLoading,
    refetch: refetchPrevYearsCount,
    isRefetching: isRefetchingPrevYearsCount,
  } = useGetDashboardCount({
    communityId: communityDetail?.communityId,
    year: currentFinanceYear,
    queryParams: {
      enabled: !!(communityDetail?.communityId && currentFinanceYear),
    },
  });

  useEffect(() => {
    if (currentFinanceYear) {
      refetchPrevYearsCount();
    }
  }, [currentFinanceYear]);

  const summaryCards = useMemo(() => {
    if (!prevYearsCounts?.data) return cards;
    const prevCounts = prevYearsCounts?.data;
    return cards?.map((data: any) => {
      const isAccReceievables = data?.amtKey == "actualRecievables";
      let per = 0;
      if (isAccReceievables) {
        per = ((prevCounts[data?.amtKey] * 100) / prevCounts["currentYearBudget"])
      }

      return ({
        ...data,
        amt: formatCurrencyShort(prevCounts[data?.amtKey] || "0"),
        title: data?.titleSuffix ? `${currentFinanceYear} ${data.titleSuffix}` : data?.title,
        subTitle: isAccReceievables ? `${parseFloat(per?.toString()).toFixed(2)}% of Budget` : data?.subTitle,
        footerText: data?.footerTextKey ? `Approved On: ${prevCounts[data?.footerTextKey] ? moment(prevCounts[data?.footerTextKey]).format("MM/DD/YYYY") : "-"}` : data?.footerText
      })
    })
  }, [prevYearsCounts]);
  
  return {
    summaryCards,
    isPrevYearsCountsLoading,
    isRefetchingPrevYearsCount
  }
}

export default useBudgetCard;